<div class=" " *ngIf="showRequest" [class.read-only-content]="isReadOnly">
  <h2 class="sectionTitle" *ngIf="!isReadOnly">{{ 'FRONT_USER.DYNAMIC_BALANCE_REQUEST_FORM.TITLE' | translate }}</h2>
    <!--request Details summary-->
    <app-request-details *ngIf="requestId" [baseRequest]="baseRequestDTO"></app-request-details>
    <!--request -->

  <form [formGroup]="dynamicbalancingRequestForm"  *ngIf="!showSuccessMessage" >

    <fieldset [disabled]="isReadOnly" >
      <div class="form-container">
        <h4 class="section-title">{{ 'FRONT_USER.REQUEST_INFORMATION' | translate }}</h4>

        <!--DesiredDate-->
        <div class="form-group">
          <label for="DesiredDate">{{ 'FRONT_USER.DYNAMIC_BALANCE_REQUEST_FORM.DESIRED_DATE' | translate }}</label>
          <span class="red"> *</span>
          <input class="form-control" #datepickerMDY="bsDatepicker" bsDatepicker formControlName="DesiredDate"
            [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', containerClass : 'theme-dark-blue' }">
          <div *ngIf="submitted ||(f.DesiredDate?.errors&&f.DesiredDate?.dirty) " class="red">
            <div *ngIf="f.DesiredDate?.errors?.inValidDateError">{{'FRONT_USER.DATE_ERROR' | translate}}</div>
            <div *ngIf="f.DesiredDate?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>

          </div>
        </div>

        <!--TypeOfUnit-->
        <div class="form-group">
          <label for="TypeOfUnit">{{'FRONT_USER.DYNAMIC_BALANCE_REQUEST_FORM.TYPE_UNIT' | translate}}</label>

          <select (change)="changeUnit($event.target.value)" id="TypeOfUnitId" name="TypeOfUnitId" class="form-control"
            formControlName="TypeOfUnitId">
            <option [value]='null' selected>
              {{'FRONT_USER.DYNAMIC_BALANCE_REQUEST_FORM.CHOOSE_TYPE_UNIT' | translate}}</option>
            <ng-container *ngFor="let typeunit of typeOfUnit">
              <option *ngIf="displayedLang=='NameEN'" [value]="typeunit.Id">
                {{typeunit.NameEN}}
              </option>
              <option *ngIf="displayedLang=='NameAR'" [value]="typeunit.Id">
                {{typeunit.NameAR}}
              </option>
            </ng-container>
          </select>
        </div>


        <!--OthersTypeOfUnit-->
        <div class="form-group" *ngIf="showOtherDiv">
          <label
            for="OthersTypeOfUnit">{{ 'FRONT_USER.DYNAMIC_BALANCE_REQUEST_FORM.OTHER_UNIT_TYPES'| translate}}</label>
          <span class="red"> *</span>
          <input type="text" class="form-control" id="OthersTypeOfUnit" name="OthersTypeOfUnit"
            formControlName="OthersTypeOfUnit" />
          <div *ngIf="submitted ||(f.OthersTypeOfUnit?.dirty && f.OthersTypeOfUnit?.errors) " class="red">
            <div *ngIf="f.OthersTypeOfUnit?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
          </div>
        </div>

        <!--UnitWeight-->
        <div class="form-group">
          <label for="UnitWeight">{{ 'FRONT_USER.DYNAMIC_BALANCE_REQUEST_FORM.UNIT_WEIGHT' | translate}}</label>
          <span class="red"> *</span>
          <div class="input-group">
            <input type="text" class="form-control" id="UnitWeight" name="UnitWeight" formControlName="UnitWeight" />
            <span class="input-group-addon">{{ 'FRONT_USER.DYNAMIC_BALANCE_REQUEST_FORM.KG' | translate}}</span>
          </div>
          <div *ngIf="submitted||(f.UnitWeight?.dirty && f.UnitWeight?.errors) " class="red">
            <div *ngIf="f.UnitWeight?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
            <div *ngIf="f.UnitWeight?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>
          </div>
        </div>
        <!--OperationSpeed-->
        <div class="form-group">
          <label for="OperatingSpeed">{{ 'FRONT_USER.DYNAMIC_BALANCE_REQUEST_FORM.OPERATION_SPEED' | translate}}</label>
          <span class="red"> *</span>
          <div class="input-group">
            <input type="text" class="form-control" id="OperatingSpeed" name="OperatingSpeed"
              formControlName="OperatingSpeed" />
            <span class="input-group-addon">{{ 'FRONT_USER.DYNAMIC_BALANCE_REQUEST_FORM.RPM' | translate}}</span>
          </div>
          <div *ngIf="submitted|| (f.OperatingSpeed?.dirty && f.OperatingSpeed?.errors) " class="red">
            <div *ngIf="f.OperatingSpeed?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
            <div *ngIf="f.OperatingSpeed?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>
          </div>
        </div>


        <!-- VesselName -->

        <div class="form-group">
          <label for="VesselName">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.VESSEL_NAME' | translate}}</label>
          <span class="red"> *</span>
          <input type="text" class="form-control" id="VesselName" name="VesselName" formControlName="VesselName" />
          <div *ngIf="submitted ||(f.VesselName?.errors&&f.VesselName?.dirty)" class="red ">
            <div *ngIf="f.VesselName?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
            <div *ngIf="f.VesselName?.errors?.maxlength">{{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
            </div>
            <div *ngIf="f.VesselName?.errors?.pattern">{{'FRONT_USER.CHARACTER_ERROR' | translate}}
            </div>

          </div>
        </div>

        <!-- NearestLocation -->
         <div class="form-group">
          <label id="example-radio-group-label">{{'FRONT_USER.Floating_Carnes_Request_Form.NearestLocation'|translate}}</label>
          <span class="red"> *</span>
          <div class="form-custom-inputs">
            <div class="custom-Radio"  *ngFor="let location of nearestLocationKeys;let i='index'">
              <input  [id]="[location]"  type="radio"  name="NearestLocation"   [value]="nearestLocation[location]"
                 formControlName="NearestLocation" />
              <label [for]="[location]">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.' + location | translate }}</label>
            </div>
          </div>
          <!-- <div *ngIf="submitted && f.NearestLocation?.errors" class="red ">
            <div *ngIf="f.NearestLocation?.errors?.required">
              {{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
          </div> -->
        </div>
      </div>

      <!--Description-->
      <div class="form-container">
        <div class="form-group">
          <label for="Description">{{ 'FRONT_USER.DYNAMIC_BALANCE_REQUEST_FORM.DESCRIPTION' | translate }}</label>
          <textarea class="form-control" id="Description" name="Description" formControlName="Description"></textarea>
          <div *ngIf="submitted ||(f.Description?.errors&&f.Description?.dirty)" class="red ">

            <div *ngIf="f.Description?.errors?.maxlength">
              {{'FRONT_USER.REPAIR_REQUEST_FORM.WORK_DESCRIPTION_MAX_LENGTH_ERROR' | translate}}</div>
            <div *ngIf="f.Description?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}
            </div>
          </div>
        </div>
      </div>

      <!--Drawing-->
      <div *ngIf="!isReadOnly">
        <div class="form-container">
          <h4 class="section-title">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ATTACHMENTS' | translate}}</h4>
          <div class="form-group">
            <label for="Drawings">{{ 'FRONT_USER.DYNAMIC_BALANCE_REQUEST_FORM.DRAWING' | translate}}</label>
            <div>
              <input type="file" accept=".pdf,.bmp,.doc,.docx,.gif,.jpg,.jpeg,.png" MaxSizeInMB="5" class="form-control"
              id="Drawings" formControlName="Drawings"
              (change)="onFileSelected($event,f.Drawings,'Dynamic_balancing_Drawings',13,'drawingsFileProgress', 'FRONT_USER.DYNAMIC_BALANCE_REQUEST_FORM.DRAWING')" />

            </div>
              <div class="upload-info">
              <span>{{'FRONT_USER.DYNAMIC_BALANCE_REQUEST_FORM.AllowedFileExtentionsTitle' | translate}}</span>
              <span>{{'FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle' | translate}}</span>
            </div>
            <div *ngIf="submitted && f.Drawings?.errors ||(f.Drawings?.errors && f.Drawings?.dirty)" class="red ">
            {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}
          </div>


            <div class="progress">
              <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                [style.width]="drawingsFileProgress + '%'">
                <span class=""> {{drawingsFileProgress}} % Complete</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isReadOnly && drawingAttachmentExist">
        <div class="form-container read-uploaded">
          <h4 class="section-title">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ATTACHMENTS' | translate}}</h4>
          <div class="form-group">
            <label>{{ 'FRONT_USER.DYNAMIC_BALANCE_REQUEST_FORM.DRAWING' | translate}}</label>
            <a [attr.href]="drawingAttachmentUrl" target="_blank">
              <i class="icon-view-file"></i>
                {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}


            </a>
          </div>
        </div>
      </div>
    </fieldset>

    <app-user-request-details [UserRequestDetailsformGroup]="dynamicbalancingRequestForm" [IsReadOnly]="isReadOnly"
      [SubmitFlag]="submitted" [extrnalData]="userInfo"  [IsCustomerName]="true" ></app-user-request-details>



      <!-- TermaAndConditions -->
     <div class="form-group" *ngIf="!isReadOnly">
      <label for="TermsAndConditions">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.TERMS_CONDITIONS' | translate }}</label>
      <span class="red"> *</span>
      <div class="custom-checkbox">
        <input type="checkbox" class="form-control" id="TermsAndConditions" name="TermsAndConditions"
          formControlName="TermsAndConditions" />
          <label for="TermsAndConditions">
           <a (click)="goToTermsAndConditions()" target="_blank" > {{ 'FRONT_USER.SALVAGE_REQUEST_FORM.TERMS_CONDITIONS_Acceptence' | translate }}</a>
          </label>



      </div>
      <div *ngIf="submitted && f.TermsAndConditions?.errors" class="red ">
        <div *ngIf="f.TermsAndConditions?.errors?.required">{{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
      </div>

    </div>

    <div class="form-group" *ngIf="!isReadOnly">
      <button Confirmation (confirmationClick)="onSubmit()"  [disabled]="loading" class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.SAVE' | translate}}</button>
    </div>
    <!-- </div> -->
  </form>
</div>

<!-- Confirmation -->
<div *ngIf="!showRequest&&!isErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p> {{ 'FRONT_USER.SUCCESS_MESSAGE' | translate }}
    </p>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>

<!-- error message -->
<div *ngIf="!showRequest&&isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>

    </div>
</div>

<div *ngIf="requestId">
  <app-messaging></app-messaging>
</div>
